import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaMagnifyingGlass } from "react-icons/fa6";
import AttendanceOverview from "./index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_ATTENDANCE_OVERVIEW } from "variables/constants";

const attendanceRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Attendance Overview",
		basePath: "attendance-overview",
		mainComponent: <AttendanceOverview/>,
	    layout: "/console",	   
	    icon: <FaMagnifyingGlass className="icon-item" />,
	    subTitle:"Attendance Overview",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_ATTENDANCE_OVERVIEW,
	})
]

export default attendanceRoutes;